import Vue from 'vue'

Vue.filter('money', function (value) {
  return new Intl.NumberFormat('fr-CA', { style: 'currency', currency: 'CAD', currencyDisplay: "symbol" }).format(value)
})

Vue.filter('shortdate', function (value) {
  let date
  // Parse YYYY-MM-DD strings as local dates to avoid timezone shift
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number)
    date = new Date(year, month - 1, day)
  } else {
    date = new Date(value)
  }
  return date.toLocaleDateString('fr-CA')
})

Vue.filter('longdate', function (value) {
  let date
  // Parse YYYY-MM-DD strings as local dates to avoid timezone shift
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number)
    date = new Date(year, month - 1, day)
  } else {
    date = new Date(value)
  }
  return date.toLocaleDateString('fr-CA', {
    dateStyle: "long"
  })
})